<template>
  <div>
    <XDateType
      v-if="showDateType"
      :label="labelIcon(reactionIcon)"
      :icon="reactionIcon"
      :date="reaction.relativeDate"
      :interestsFlag="interestsFlag"
      :text="ctaBanner.text"
      :textColor="ctaBanner.color"
      :textBackgroundColor="ctaBanner.backgroundColor"
    />

    <XHijackCard
      v-if="reaction.data.hijack"
      :hijack="reaction.data.hijack"
      :cardComponent="cardComponent"
      :class="{ 'overflow-hidden': lockedContent }"
      @locked="onLockContent"
      @unlocked="onUnLockContent"
      @rescuePaid="rescuePaid"
    >
      <component
        slot-scope="{ initHijack }"
        :is="mediaTypeComponent"
        :url="mediaUrl"
        :thumbnail="reaction.data.thumbnail"
        :to="reaction.data.url"
        :oembed="reaction.data.oembed"
        @mediaLoaded="initHijack"
      >
        <XReactionFooter
          v-if="showFooter"
          slot="footer"
          :reaction="reaction"
          :shareChannels="shareChannelsWithoutDownload"
          :shareMessage="shareMessage"
          :shareHashtags="shareHashtags"
          :shareDescription="shareDescription"
          :showShare="showShare"
          :showExpressions="showExpressions"
        />
      </component>
    </XHijackCard>

    <component
      v-else
      :is="cardComponent"
    >
      <component
        :is="mediaTypeComponent"
        :url="mediaUrl"
        :thumbnail="thumbnailUrl"
        :to="reaction.data.url"
        :oembed="reaction.data.oembed"
        :reaction="reaction"
        @mediaLoaded="mediaLoaded"
      >
        <XReactionFooter
          v-if="showFooter"
          slot="footer"
          :reaction="reaction"
          :shareChannels="shareChannelsWithoutDownload"
          :shareMessage="shareMessage"
          :shareHashtags="shareHashtags"
          :shareDescription="shareDescription"
          :showShare="showShare"
          :showExpressions="showExpressions"
        />
      </component>
    </component>
  </div>
</template>

<script>
import _ from 'lodash'

import XImage from './types/Image'
import XVideo from './types/Video'
import XLink from './types/Link'
import XOembed from './types/Oembed'
import XEmbed from './types/Embed'
import XZoomMeeting from './types/ZoomMeeting'

import XHijackCard from './HijackCard'

import ReactionMixin from '../ReactionMixin'

export default {
  mixins: [
    ReactionMixin
  ],

  components: {
    XImage,
    XVideo,
    XLink,
    XOembed,
    XEmbed,
    XHijackCard,
    XZoomMeeting
  },

  props: {
    allowHijack: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      lockedContent: true,
      flipped: false,
      playerOptions: {
        language: 'es',
        sources: [{
          type: 'video/mp4',
          src: this.reaction.data.url
        }]
      },
      shareChannelsWithoutDownload: this.shareChannels
        ? this.shareChannels.filter(value => {
          return value !== 'download'
        })
        : [],
      showInterests: false
    }
  },

  computed: {
    interestsFlag () {
      return this.hasInterestFlag
        ? this.$t('event.timeline.broadcast.interestsFlag') + ' ' + this.reaction.data.interestsFilter.join(', ')
        : ''
    },

    hasInterestFlag () {
      return this.reaction.data &&
             this.reaction.data.interestsFilter &&
             Array.isArray(this.reaction.data.interestsFilter) &&
             this.reaction.data.interestsFilter.length > 0
    },

    showFooter () {
      if (
        this.reaction.data &&
        this.reaction.data.design
      ) {
        return (this.reaction.data.design.showExpressions || this.reaction.data.design.showShare) && this.shareChannels
      }

      return this.shareChannels
    },

    reactionIcon () {
      if (this.reaction.data && this.reaction.data.timelineIcon) {
        return 'fa/light/' + this.reaction.data.timelineIcon
      }

      if (this.reaction.data && this.reaction.data.design) {
        return 'fa/light/' + this.reaction.data.design.timelineIcon
      }

      return 'fa/light/bullhorn'
    },

    mediaType () {
      return this.reaction.data.type === 'videoRaw'
        ? 'video'
        : 'image'
    },

    mediaUrl () {
      if (this.reaction.data.url) {
        if (this.reaction.data.type === 'gif' || this.reaction.data.type === 'videoRaw') {
          return this.reaction.data.url
        }

        return this.reaction.data.url
      }

      return this.reaction.url
    },

    thumbnailUrl () {
      return this.reaction.data.thumbnail || this.mediaUrl
    },

    mediaTypeComponent () {
      if (this.reaction.data.hasOwnProperty('zoomMeeting')) {
        if (this.reaction.data.zoomMeeting.enable) {
          return 'XZoomMeeting'
        }
      }

      if (this.reaction.data.hasOwnProperty('oembed')) {
        return 'XOembed'
      }

      const hasVideoUrl = this.reaction.data.url &&
                          this.reaction.data.url.split('.mp4').length === 2

      if (this.reaction.data.type === 'videoRaw' || hasVideoUrl) {
        return 'XVideo'
      }

      if (this.reaction.data.url) {
        return 'XLink'
      }

      if (this.reaction.data.thumbnailType === 'embed') {
        return 'XEmbed'
      }

      return 'XImage'
    },

    ctaBanner () {
      let defaultBanner = { position: 'top', enable: false }
      let ctaBanner = this.reaction.data &&
                      this.reaction.data.design
        ? this.reaction.data.design.ctaBanner
        : defaultBanner

      return {
        ...ctaBanner,
        slot: 'ctaBanner' + _.upperFirst(ctaBanner.position)
      }
    },

    cardComponent () {
      if (
        this.reaction.data &&
        this.reaction.data.design
      ) {
        return this.reaction.data.design.withCardStyle ? 'XCard' : 'div'
      }

      return 'XCard'
    }
  },

  mounted () {
    if (!this.reaction.data.hijack) {
      this.lockedContent = false
    }
  },

  methods: {
    mediaLoaded () {
      this.showInterests = true
    },

    onUnLockContent () {
      this.lockedContent = false
    },

    onLockContent () {
      this.lockedContent = true
    },

    rescuePaid (data) {
      if (data && data.event) {
        this.$emit(data.event, data.props)

        return
      }

      this.$emit('rescuePaid', data.props)
    }
  }
}
</script>
